import { status } from "../untils";
import config from '../config-site'
import axios from 'axios';



AbortSignal.timeout ??= function timeout(ms) {
    const ctrl = new AbortController()
    setTimeout(() => ctrl.abort(), ms)
    return ctrl.signal
}

const address_api = config[0].address;

export function setVoteCommand(token, user, material, description, vote){
    return fetch(`${address_api}/api/votes/?material=${material}`, {
        method : 'POST',
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': `Token ${token}`
        },
        body: JSON.stringify({user, material, description, vote})
    }).then(status).catch( e => {console.log(e);})
}


export function getVoteComments(token, material){
    // return fetch(`${address_api}/api/votes/?material=${material}`, {
    //     method : 'GET',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         // 'Authorization': `Token ${token}`,
    //     },
    //     // body: JSON.stringify({'material':material})
    // })
    // .then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/votes/?material=${material}`,
        method: "get",
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': `Token ${token}`
        },
	    withCredentials: true,
        // data: JSON.stringify(userdata),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function addCreditPays(token, items){
    return fetch(`${address_api}/api/sell_detail_pays/`, {
        method : 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        body: JSON.stringify(items)
    }).then(status).catch( e => {console.log(e);})
}

export function setCreditPays(token, pay_id, items){
    return fetch(`${address_api}/api/sell_detail_pays/${pay_id}/`, {
        method : 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        body: JSON.stringify(items)
    }).then(status).catch( e => {console.log(e);})
}

export function delCreditPays(token, pay_id){
    return fetch(`${address_api}/api/sell_detail_pays/${pay_id}/`, {
        method : 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
    }).then(status).catch( e => {console.log(e);})
}

export function getPayTag(token){
    // return fetch(`${address_api}/api/pay_tags/`, {
    //     method : 'GET',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`
    //     },
    // }).then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/pay_tags/`,
        method: "get",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
	    withCredentials: true,
        // data: JSON.stringify(userdata),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function getSellMatPays(token, mat_id){
    // return fetch(`${address_api}/api/sell_materials/place_pay_get/?token=${token}&mat_id=${mat_id}`, {
    //     method : 'GET',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     },
    // })
    // .then(status).catch( e => {console.log('erroe');})
    return axios({
        url: `${address_api}/api/sell_materials/place_pay_get/?token=${token}&mat_id=${mat_id}`,
        method: "get",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
	    withCredentials: true,
        // data: JSON.stringify(userdata),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function getTotalMaterials(token, querys){
    // return fetch(`${address_api}/api/materials/?page_size=100${querys}`, {
    //     method : 'GET',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     },
    // })
    // .then(status).catch( e => {console.log('erroe');})
    return axios({
        url: `${address_api}/api/materials/?page_size=100${querys}`,
        method: "get",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
	    withCredentials: true,
        // data: JSON.stringify(userdata),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function getMaterials(page, page_size, type_data, lang_id){
    return fetch(`${address_api}/api/buy_material_details/?lang_id=${lang_id}&p=${page}&page_size=${page_size}${type_data}`)
    .then(status).catch( e => {console.log(e);})
}
// ${address_api}/api/buy_material_details/?page=2
export function getMaterial(type_data, id, lang_id){
    return fetch(`${address_api}/api/buy_material_details/${id}/?type_data=${type_data}&lang_id=${lang_id}`)
    .then(status).catch( e => {console.log(e);})
}

export function getShopingNow(token, page, page_size, querys){
    // return fetch(`${address_api}/api/request_buys/?p=${page}&page_size=${page_size}`, {
    //     method : 'GET',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     }
    // })
    // .then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/request_buys/?p=${page}&page_size=${page_size}`,
        method: "get",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
	    withCredentials: true,
        // data: JSON.stringify(userdata),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function setReadReqMessage(token, req_id){
    return fetch(`${address_api}/api/request_buys/readReqData/`, {
        method : 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
        },
        body: JSON.stringify(req_id)
    })
    .then(status).catch( e => {console.log(e);})
}

export function getReqBuyDetail(token, req_id){
    // return fetch(`${address_api}/api/request_buys/${req_id}/`, {
    //     method : 'GET',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     }
    // })
    // .then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/request_buys/${req_id}/`,
        method: "get",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
	    withCredentials: true,
        // data: JSON.stringify(userdata),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function addSellCredit(token, items){
    // return fetch(`${address_api}/api/sell_mat_credits/`, {
    //     method : 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     },
    //     body: JSON.stringify(items)
    // })
    // .then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/sell_mat_credits/`,
        method: "post",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        data: JSON.stringify(items),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function setSellCredit(token, mat_id, items){
    // return fetch(`${address_api}/api/sell_mat_credits/${mat_id}/`, {
    //     method : 'PUT',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     },
    //     body: JSON.stringify(items)
    // })
    // .then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/sell_mat_credits/${mat_id}/`,
        method: "put",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        data: JSON.stringify(items),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function getSellCredit(token, mat_id){
    // return fetch(`${address_api}/api/sell_mat_credits/getSellCreditList/?token=${token}&mat_id=${mat_id}`, {
    //     method : 'GET',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     }
    // })
    // .then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/sell_mat_credits/getSellCreditList/?token=${token}&mat_id=${mat_id}`,
        method: "get",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
	    withCredentials: true,
        // data: JSON.stringify(userdata),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function sellNewMat(token, item){
    // return fetch(`${address_api}/api/sell_material_details/place_sell/`, {
    //     method : 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     },
    //     body: JSON.stringify(item)
    // })
    // .then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/sell_material_details/place_sell/`,
        method: "post",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        data: JSON.stringify(item),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function sellDeletedMat(token, item){
    // return fetch(`${address_api}/api/sell_material_details/delete_sell/`, {
    //     method : 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     },
    //     body: JSON.stringify(item)
    // })
    // .then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/sell_material_details/delete_sell/`,
        method: "post",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        data: JSON.stringify(item),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function addSellMaterial(token, items){
    // return fetch(`${address_api}/api/sell_materials/`, {
    //     method : 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`
    //     },
    //     body: JSON.stringify(items)
    // }).then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/sell_materials/`,
        method: "post",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        data: JSON.stringify(items),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function setSellMaterial(token, id, items){
    // return fetch(`${address_api}/api/sell_materials/${id}/`, {
    //     method : 'PUT',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`
    //     },
    //     body: JSON.stringify(items)
    // }).then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/sell_materials/${id}/`,
        method: "put",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        data: JSON.stringify(items),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function getSellMaterial(token, page, page_size, items){
    // return fetch(`${address_api}/api/sell_materials/place_get/?token=${token}&page=${page}&page_size=${page_size}`, {
    //     method : 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`
    //     },
    //     body: JSON.stringify(items)
    // }).then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/sell_materials/place_get/?token=${token}&page=${page}&page_size=${page_size}`,
        method: "post",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        data: JSON.stringify(items),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function getSellMaterialList(token, user_id){
    // return fetch(`${address_api}/api/sell_materials/getSellList/?token=${token}&user_id=${user_id}`, {
    //     method : 'GET',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`
    //     },
    // }).then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/sell_materials/getSellList/?token=${token}&user_id=${user_id}`,
        method: "get",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
	    withCredentials: true,
        // data: JSON.stringify(userdata),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function getWorkList(token, mat_id){
    // return fetch(`${address_api}/api/sell_material_works/getSellWorkList/?token=${token}&mat_id=${mat_id}`, {
    //     method : 'GET',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`
    //     },
    // }).then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/sell_material_works/getSellWorkList/?token=${token}&mat_id=${mat_id}`,
        method: "get",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
	    withCredentials: true,
        // data: JSON.stringify(userdata),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function setSellWorkVote(token, items){
    // return fetch(`${address_api}/api/sell_material_work_votes/`, {
    //     method : 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`
    //     },
    //     body: JSON.stringify(items)
    // }).then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/sell_material_work_votes/`,
        method: "post",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        data: JSON.stringify(items),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function getLangProgramTag(token){
    // return fetch(`${address_api}/api/lang_program_tags/`, {
    //     method : 'GET',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`
    //     },
    // }).then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/lang_program_tags/`,
        method: "get",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
	    withCredentials: true,
        // data: JSON.stringify(userdata),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function getSellStatusTag(token){
    // return fetch(`${address_api}/api/sell_status_tags/`, {
    //     method : 'GET',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`
    //     },
    // }).then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/sell_status_tags/`,
        method: "get",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
	    withCredentials: true,
        // data: JSON.stringify(userdata),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

// export function getSellWorkList(token, user_id){
//     return fetch(`${address_api}/api/sell_material_works/?token=${token}&user_id=${user_id}`, {
//         method : 'GET',
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Token ${token}`
//         },
//     }).then(status).catch( e => {console.log(e);})
// }

export function getInbox(token, page, page_size, querys){
    // return fetch(`${address_api}/api/inboxs/?p=${page}&page_size=${page_size}${querys}`, {
    //     method : 'GET',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     }
    // })
    // .then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/inboxs/?p=${page}&page_size=${page_size}${querys}`,
        method: "get",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
	    withCredentials: true,
        // data: JSON.stringify(userdata),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function setInbox(token, data){
    // return fetch(`${address_api}/api/inboxs/place_message/`, {
    //     method : 'POST',
    //     headers: {
    //         'Authorization': `Token ${token}`,
    //     },
    //     body: data
    // })
    // .then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/inboxs/place_message/`,
        method: "post",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        data: data,
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function deletedInbox(token, item){
    // return fetch(`${address_api}/api/inboxs/delete_message/`, {
    //     method : 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     },
    //     body: JSON.stringify(item)
    // })
    // .then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/inboxs/delete_message/`,
        method: "post",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        data: JSON.stringify(item),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

// export function buyNewMat(token, item){
//     return fetch(`${address_api}/api/buy_material_details/place_buy/`, {
//         method : 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Token ${token}`,
//         },
//         body: JSON.stringify(item)
//     })
//     .then(status).catch( e => {console.log(e);})
// }

export function DeletedBuyMaterial(token, item){
    // return fetch(`${address_api}/api/buy_material_details/delete_buy/`, {
    //     method : 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     },
    //     body: JSON.stringify(item)
    // })
    // .then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/buy_material_details/delete_buy/`,
        method: "post",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        data: JSON.stringify(item),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function buyMatUpdate(token, data){
    // return fetch(`${address_api}/api/buy_material_details/place_buy/`, {
    //     method : 'POST',
    //     headers: {
    //         'Authorization': `Token ${token}`,
    //     },
    //     body: data
    // })
    // .then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/buy_material_details/place_buy/`,
        method: "post",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        data: data,
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function sellMatWorkInsert(token, data){
    // return fetch(`${address_api}/api/sell_material_works/`, {
    //     method : 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     },
    //     body: JSON.stringify(data)
    // })
    // .then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/sell_material_works/`,
        method: "post",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        data: JSON.stringify(data),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function sellMatWorkUpdate(token, WORK_ID, data){
    // return fetch(`${address_api}/api/sell_material_works/${WORK_ID}/`, {
    //     method : 'PUT',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     },
    //     body: JSON.stringify(data)
    // })
    // .then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/sell_material_works/${WORK_ID}/`,
        method: "put",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        data: JSON.stringify(data),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function sellMatWorkDelete(token, WORK_ID){
    // return fetch(`${address_api}/api/sell_material_works/${WORK_ID}/`, {
    //     method : 'DELETE',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     },
    //     // body: JSON.stringify(data)
    // })
    // .then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/sell_material_works/${WORK_ID}/`,
        method: "delete",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        // data: JSON.stringify(data),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function sellMatDetailInsert(token, data){
    // return fetch(`${address_api}/api/sell_material_details/`, {
    //     method : 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     },
    //     body: JSON.stringify(data)
    // })
    // .then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/sell_material_details/`,
        method: "post",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        // data: JSON.stringify(data),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function sellMatDetailUpdate(token, MAT_ID, data){
    // return fetch(`${address_api}/api/sell_material_details/${MAT_ID}/`, {
    //     method : 'PUT',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     },
    //     body: JSON.stringify(data)
    // })
    // .then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/sell_material_details/${MAT_ID}/`,
        method: "put",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        data: JSON.stringify(data),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function sellMatDetailDelete(token, MAT_ID){
    // return fetch(`${address_api}/api/sell_material_details/${MAT_ID}/`, {
    //     method : 'DELETE',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     },
    //     // body: JSON.stringify(data)
    // })
    // .then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/sell_material_details/${MAT_ID}/`,
        method: "delete",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        // data: JSON.stringify(data),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function getBuyMaterils(token, matBuy){
    // return fetch(`${address_api}/api/buy_materials/${matBuy}/`, {
    //     method : 'GET',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     }
    // })
    // .then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/buy_materials/${matBuy}/`,
        method: "get",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
	    withCredentials: true,
        // data: JSON.stringify(userdata),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function newMaterial(token, item){
    // return fetch(`${address_api}/api/materials/place_mat/`, {
    //     method : 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     },
    //     body: JSON.stringify(item)
    // })
    // .then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/materials/place_mat/`,
        method: "post",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        data: JSON.stringify(item),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}


export function delSellDoc(token, file_id){
    // return fetch(`${address_api}/api/sell_mat_files/${file_id}/`, {
    //     method : 'DELETE',
    //     headers: {
    //         // 'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     },
    //     // body: data
    // }).then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/sell_mat_files/${file_id}/`,
        method: "delete",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        // data: JSON.stringify(data),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function uploadSellDoc(token, data){
    // return fetch(`${address_api}/api/sell_mat_files/`, {
    //     method : 'POST',
    //     headers: {
    //         // 'Content-Type': 'multipart/form-data',
    //         'Authorization': `Token ${token}`,
    //     },
    //     body: data
    // }).then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/sell_mat_files/`,
        method: "post",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        data: data,
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function uploadImageMaterial(matID, data){
    // return fetch(`${address_api}/api/materials/${matID}/`, {
    //     method : 'POST',
    //     headers: {
    //         'Content-Type': 'multipart/form-data',
    //     },
    //     body: data
    // }).then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/materials/${matID}/`,
        method: "post",
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        withCredentials: true,
        data: data,
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function DeletedMaterial(token, mat_id){
    // return fetch(`${address_api}/api/materials/${mat_id}/`, {
    //     method : 'DELETE',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     },
    //     // body: JSON.stringify(item)
    // })
    // .then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/materials/${mat_id}/`,
        method: "delete",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        // data: JSON.stringify(data),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function DeletedMaterialDetail(token, mat_id){
    // return fetch(`${address_api}/api/imageLists/${mat_id}/`, {
    //     method : 'DELETE',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     },
    //     // body: JSON.stringify(item)
    // })
    // .then(status).catch( e => {console.log(e);})

    return axios({
        url: `${address_api}/api/imageLists/${mat_id}/`,
        method: "delete",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        // data: JSON.stringify(data),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function uploadMaterial(token, data){
    // return fetch(`${address_api}/api/materials/place_mat/`, {
    //     method : 'POST',
    //     headers: {
    //         'Authorization': `Token ${token}`,
    //     },
    //     body: data
    // }).then(status).catch( e => {console.log(e);})

    return axios({
        url: `${address_api}/api/materials/place_mat/`,
        method: "post",
        headers: {
            // 'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        // data: JSON.stringify(data),
        data: data,
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function setReqFree(token, data){
    // return fetch(`${address_api}/api/request_buys/place_req_buy/`, {
    //     method : 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     },
    //     // body: data
    //     body: JSON.stringify(data)
    // }).then(status).catch( e => {console.log(e);})
    
    return axios({
        url: `${address_api}/api/request_buys/place_req_buy/`,
        method: "post",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        data: JSON.stringify(data),
        // data: data,
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function getMatGroups(lang_id, data_type){
    
    // return fetch(`${address_api}/api/material_groups/?p=${page}&page_size=${page_size}${querys}`, {
    // return fetch(`${address_api}/api/material_groups/?lang_id=${lang_id}${data_type}`, {
    //         method : 'GET',
    //     headers: {
    //         'Content-Type': 'application/json',
    //     }
    // })
    // .then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/material_groups/?lang_id=${lang_id}${data_type}`,
        method: "get",
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': `Token ${token}`
        },
	    withCredentials: true,
        // data: JSON.stringify(userdata),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function getAllDatas(){
    
    return axios({
        url: `${address_api}/api/material_groups/place_get/`,
        method: "post",
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': `Token ${token}`
        },
	    withCredentials: true,
        // data: JSON.stringify(userdata),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function DeletedMatGroup(token, item){
    // return fetch(`${address_api}/api/material_groups/delete_material/`, {
    //     method : 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     },
    //     body: JSON.stringify(item)
    // })
    // .then(status).catch( e => {console.log(e);})
    
    return axios({
        url: `${address_api}/api/material_groups/delete_material/`,
        method: "post",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        data: JSON.stringify(item),
        // data: data,
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function uploadMaterialGroup(token, data){
    // return fetch(`${address_api}/api/material_groups/place_mat/`, {
    //     method : 'POST',
    //     headers: {
    //         'Authorization': `Token ${token}`,
    //     },
    //     body: data
    // }).then(status).catch( e => {console.log("Error uploadMaterialGroup:", e);})
    
    return axios({
        url: `${address_api}/api/material_groups/place_mat/`,
        method: "post",
        headers: {
            // 'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        // data: JSON.stringify(item),
        data: data,
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function uploadImageList(token, data){
    // return fetch(`${address_api}/api/imageLists/place_image_list/`, {
    //     method : 'POST',
    //     headers: {
    //         'Authorization': `Token ${token}`,
    //     },
    //     body: data
    // }).then(status).catch( e => {console.log(e);})
    
    return axios({
        url: `${address_api}/api/imageLists/place_image_list/`,
        method: "post",
        headers: {
            // 'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        // data: JSON.stringify(item),
        data: data,
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}


export function deleteLink(token, item){
    // return fetch(`${address_api}/api/link_make_desc/delete_link/`, {
    //     method : 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     },
    //     body: JSON.stringify(item)
    // })
    // .then(status).catch( e => {console.log(e);})
    
    return axios({
        url: `${address_api}/api/link_make_desc/delete_link/`,
        method: "post",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        data: JSON.stringify(item),
        // data: data,
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function addImagesLink(token, item){
    // return fetch(`${address_api}/api/link_make_desc/`, {
    //     method : 'PUT',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     },
    //     body: JSON.stringify(item)
    // })
    // .then(status).catch( e => {console.log(e);})
    
    return axios({
        url: `${address_api}/api/link_make_desc/`,
        method: "put",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        data: JSON.stringify(item),
        // data: data,
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function updateImagesLink(token, linkId, item){
    // console.log("updateImagesLink", linkId, item);
    // return fetch(`${address_api}/api/link_make_desc/${linkId}/`, {
    //     method : 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //     },
    //     body: JSON.stringify(item)
    // })
    // .then(status).catch( e => {console.log(e);})
    
    return axios({
        url: `${address_api}/api/link_make_desc/${linkId}/`,
        method: "post",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
        withCredentials: true,
        data: JSON.stringify(item),
        // data: data,
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

